import { EditableQuery } from 'modules/queryBuilder/types';
import { applyCriteriaTransformations } from './applyCriteriaTransformations';

/**
 * Applies schema transformations to a complete query
 * This allows the same transformations used in schema validation to be applied to data directly
 * Any transformtion that is applied during schema validation must also be added to the relevant level apply function
 */
export const applyQueryTransformations = (query: EditableQuery): EditableQuery => {
  return {
    ...query,
    searchQueries: query.searchQueries.map((criteria) => applyCriteriaTransformations(criteria)),
  };
};
